import { useQuery } from '@tanstack/react-query';

import { RESPONSE_ITEMS_PER_PAGE } from 'src/constants';
import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import { ApplicationResponsePaginationItemsContainer } from 'src/types/rest/tenant';

export const useApplicationListApplications = (applicationListId?: string) => {
  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useQuery({
    enabled: !!applicationListId,
    queryFn: () =>
      apiRequest<ApplicationResponsePaginationItemsContainer>({
        url: `${apiHost}/application-lists/${applicationListId}/applications?PageIndex=1&ItemsPerPage=${RESPONSE_ITEMS_PER_PAGE}`,
      }),
    queryKey: ['applicationlist', applicationListId, 'applications'],
  });
};
